

import React, {
    useMemo
} from 'react';
import { Link } from "react-router";
import { useQuery } from '@tanstack/react-query';

import config from "../config/config";
import * as QUERIES from "../queries/query-functions";
import * as UTILS from "../utils/utils";

import LoadingIndicator from './loading-indicator';

const TicketCard = (props) => {

    const event = props.ticket?.instance?.event;

    const formattedDate = useMemo(() => {
        return UTILS.formatDateTime(props.ticket.instance.start)// Formats to a readable date
    }, [props.ticket.instance.start])
    
    const { 
        isPending,
        isFetching,
        data: imageData,
    } = useQuery({
        queryKey: ['imageData', props.ticket.instance?.event?.id],
        queryFn: () => QUERIES.getEventImage(props.ticket.instance?.event?.id),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000,
        enabled: !!event?.id
    });

    if (!event) return null;
    return (
        <div className='ticket-card'>
            <div className='basket-item__image'>
                {isPending || isFetching ?
                    <LoadingIndicator />
                : imageData ?
                    <div dangerouslySetInnerHTML={{__html: imageData}}></div>
                : config.LOGO_URLS?.site ?
                    <img src={config.LOGO_URLS?.site} className='basket-item__image--logo' />
                : null
                }
            </div>
            
            <div className='basket-item__summary instance-event-summary'>
                <h2 className='basket-item__title instance-event-summary__title'>{event.name}</h2>
                <p className='basket-item__date instance-event-summary__date'>{formattedDate}</p>

                <div className='instance-event-summary__button__flex'>
                    {event[`attribute_${config.OPTION_FIELDS.venue_attribute_name}`] ?
                        <div className='basket-item__venue instance-event-summary__venue'>
                            {config.LOGO_URLS[event[`attribute_${config.OPTION_FIELDS.venue_attribute_name}`]] ?
                                <img src={config.LOGO_URLS[event[`attribute_${config.OPTION_FIELDS.venue_attribute_name}`]] } className={`basket-item__image--logo ${event[`attribute_${config.OPTION_FIELDS.venue_attribute_name}`]}`} />
                            : 
                                <p>{event[`attribute_${config.OPTION_FIELDS.venue_attribute_name}`]}</p>    
                            }
                        </div>
                    :null}

                    {props.type == "upcoming" &&
                        <Link to={`/account/orders/tickets/${props.ticket.instance.id}`} className='btn'>View tickets</Link>
                    }
                </div>
            </div>
        </div>
    );
};

export default TicketCard;
